import CopilotThreadsAPI from 'dashboard/api/aidexacx/copilotThreads';
import { createStore } from '../storeFactory';

export default createStore({
  name: 'CopilotThreads',
  API: CopilotThreadsAPI,
});
